<!--
  ~ Copyright (c) 2022.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
    <li class="breadcrumb-item">
      <span i18n="@@removalPoints">Removal points</span>
    </li>
  </ol>
</div>

<!-- TODO START remove me when transfer to Secanim is finished  -->
<app-provalt-banner-collectable></app-provalt-banner-collectable>
<!-- TODO End remove me when transfer to Secanim is finished  -->

<div class="page-content fade-in-up">
  <div class="ibox">
    <div class="ibox-head">
      <div class="ibox-title" i18n="@@yourRemovalPoints">Your removal points</div>
    </div>

    <div class="ibox-body">
      <div class="row mb-3">
        <div class=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <app-select-third-parties controlName="thirdParty" [formGroup]="removalPointsFG" [showLabel]="false"
                                    showValidation="no" (updated)="tpChange($event)">
          </app-select-third-parties>

        </div>
      </div>

      <div class="row mb-3" *ngIf="thirdPartyId">
        <div class=" col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <button class="btn btn-success btn-rounded btn-block" i18n="@@addRemovalPoint" (click)="showAddForm()">
            Add a removal point
          </button>
        </div>
      </div>

      <div class="row mb-3" *ngIf="thirdPartyId">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="purple-borders p-2 mt-2" *ngFor="let rp of removalPoints; let i = index">
            <app-adapter-removal-point [data]="rp" [position]="i+1" (updated)="loadRemovalPoints()">
            </app-adapter-removal-point>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
